<div class="qo-spacing mt-4 md:mt-16 mb-6 text-center" responsive #responsive="responsive">
    <h1 class="font-display font-medium text-base sm:text-xl md:text-2xl mb-4 uppercase opacity-60" i18n>Communication</h1>
    <h2 class="font-title font-black text-4xl/tight sm:text-6xl/tight md:text-7xl/tight mb-4" i18n>Une aventure humaine !</h2>
</div>

<div class="qo-spacing mx-auto max-w-4xl text-center my-4">
    <p class="mb-8" i18n>Organiser un événement, c'est s'engager dans une aventure humaine faite de partage et d'interaction. Fédérez vos équipes autour d'un projet commun en établissant une relation durable.</p>
    <p></p>
</div>

<div class="qo-spacing-sm mb=y-12 md:mt-16 md:mb-48 max-w-screen-lg mx-auto">
    <iframe class="block aspect-bg-video shadow-screen" src="https://player.vimeo.com/video/665910779?background=1" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-44">
    <div class="">
        <h2 class="mb-8" i18n>Interagissez avec vos équipes.</h2>
        <p class="mb-8" i18n>Echangez des informations ou encore des documents via la messagerie intégrée à Qoezion. L'envoi de SMS vous assurera d'être réactif en réponse aux situations qui l'exigent.</p>

    </div>

    <div class="relative">
        <div class="bg-qo-color3/60 absolute top-1/4 bottom-1/4 left-1/4 w-4/7 rounded-4xl"></div>
        <picture>
            <source [srcset]="assetsPath + 'chat.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'chat.png'" type="image/png">
            <img class="qo-img-crisp relative shadow-screen w-auto sm:w-60 md:w-278px h-96 sm:h-auto mx-auto" width="278" height="603" [src]="assetsPath + 'chat.png'" alt="" loading="lazy"/>
        </picture>
        <img class="absolute top-4 left-1/2 -translate-x-1/2 w-88 sm:w-auto" [src]="assetsPath + 'chat-sms.svg'" alt="" loading="lazy" />
    </div>
</div>  

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-72">
    <div class="md:order-2">
        <h2 class="mb-8" i18n>Offrez un service de qualité.</h2>
        <p class="mb-8" i18n>Sur son espace personnel, chacun de vos bénévoles et membres du staff aura accès aux services essentiels à une expérience réussie : messagerie, planning, restauration, cartographie... Vous renforcerez ainsi le sentiment d’appartenance en favorisant une diffusion fluide de l'information.</p>

    </div>

    <div class="md:order-1 relative">
        
        <picture>
            <source [srcset]="assetsPath + 'teammate-space.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'teammate-space.jpg'" type="image/jpg">
            <img class="qo-img-crisp relative shadow-screen w-full rounded-xl max-w-595px" width="597" height="412" [src]="assetsPath + 'teammate-space.jpg'" alt="" loading="lazy"/>
        </picture>
        <img class="absolute bottom-8 -right-2 sm:-right-16 z-10 w-1/3 md:w-auto shadow-screen rounded-2xl md:rounded-4xl" [src]="assetsPath + 'teammate-nav.svg'" alt="" loading="lazy" />
    </div>
</div>  

<div class="qo-spacing max-w-2xl md:max-w-qo mx-auto md:grid md:gap-24 lg:gap-48 md:grid-cols-2 items-center my-16 md:my-56">
    <div class="">
        <h2 class="mb-8" i18n>Construisez et fidélisez votre communauté.</h2>
        <p class="mb-8" i18n>Constituez votre communauté au fil de vos événements afin de valoriser l'engagement de vos bénévoles et de votre staff, de les fidéliser et de pouvoir maintenir le lien avec eux sur la durée.</p>

    </div>

    <div class="">
        <picture>
            <source [srcset]="assetsPath + 'build-community.webp'" type="image/webp">
            <source [srcset]="assetsPath + 'build-community.png'" type="image/png">
            <img class="relative mx-auto" width="544" height="372" [src]="assetsPath + 'build-community.png'" alt="" loading="lazy"/>
        </picture>
    </div>
</div>  


<div class="qo-spacing-md mb-12 lg:mb-56">
    <qo-customer-story theme="qoezion"></qo-customer-story>
</div>

<div class="qo-spacing max-w-screen-md mx-auto my-16 sm:my-20">
    <h2 class="text-center mb-14" i18n><span class="block text-qo-qoezion dark:text-qo-qoezionDark">Vous aussi,</span>rejoignez les nombreux événements qui font confiance à Qoezion !</h2>

    <qo-try-and-book class="flex justify-center"></qo-try-and-book>
</div>

<qo-poster-list></qo-poster-list>